(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-default-events.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-default-events.js');
"use strict";


const {
  useEffect
} = React;

const useDefaultEventsLeiaFactory = props => {
  useEffect(() => {
    const defaultEventsLeia = svs.ticketgames.ticketUtility.utils.defaultEventsLeiaFactory(props);
    defaultEventsLeia.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      defaultEventsLeia.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, []);
};
setGlobal('svs.ticketgames.ticketUtility.utils.useDefaultEventsLeiaFactory', useDefaultEventsLeiaFactory);

 })(window);